module.exports = __webpack_public_path__ + "313b58f9b7ca9917e8a128161e1dec48.png";